/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_Notes_TitleInputs */

const en_homepage_features_notes_title = /** @type {(inputs: Homepage_Features_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One click note taking`)
};

const es_homepage_features_notes_title = /** @type {(inputs: Homepage_Features_Notes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toma notas con un clic`)
};

/**
* | output |
* | --- |
* | "One click note taking" |
*
* @param {Homepage_Features_Notes_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_notes_title = /** @type {((inputs?: Homepage_Features_Notes_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_Notes_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_notes_title(inputs)
	return en_homepage_features_notes_title(inputs)
});